<template>
  <div>
    <!-- avoid caller style to be conflicted with list's negative margin -->
    <ul :class="$style.options" v-if="!preview">
      <li :class="$style.options__item" v-for="item in options" :key="item.id">
        <label :class="$style.option">
          <DolphinCheckbox :value="item.id" v-model="_value" />
          <span :class="$style.option__text">{{ item.name }}</span>
        </label>
      </li>
    </ul>
    <div v-else :class="$style.preview">
      <p :class="$style.preview__body" v-if="_value.length > 0">
        {{ selected }}
      </p>
      <slot v-else name="empty" />
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import DolphinCheckbox from '@/components/atoms/DolphinCheckbox.vue'
import type {
  Jisx0402District,
  Jisx0402Code,
} from '@/features/prefecture/jisx0402'
import {
  PREFECTURE_CODES,
  PREFECTURE_CODE_MAP,
} from '@/features/prefecture/jisx0402'

export default defineComponent({
  name: 'CorporationEditorPrefecturesInput',
  components: {
    DolphinCheckbox,
  },
  props: {
    preview: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Array as PropType<Jisx0402Code[]>,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  computed: {
    options(): readonly Jisx0402District[] {
      return PREFECTURE_CODES
    },
    optionsMap(): Record<Jisx0402Code, Jisx0402District> {
      return PREFECTURE_CODE_MAP
    },
    selected(): string {
      const map = this.modelValue.reduce<Record<Jisx0402Code, true>>(
        (accumulator, code) => ({ ...accumulator, [code]: true }),
        {} as Record<Jisx0402Code, true>
      )
      return this.options
        .filter(distinct => map[distinct.id] ?? false)
        .map(distinct => distinct.name)
        .join(', ')
    },
    _value: {
      get(): unknown[] {
        return this.modelValue
      },
      set(values: Jisx0402Code[]) {
        this.$emit('update:modelValue', values)
      },
    },
  },
})
</script>

<style lang="scss" module>
$gap: 8px;

.list {
  display: flex;
  flex-wrap: wrap;
  margin-top: -$gap;
  margin-left: -$gap;

  &__item {
    margin-top: $gap;
    margin-left: $gap;
    color: $color-text-and-object-accent-primary;
    font-size: 10px;
  }
}

.options {
  display: grid;
  justify-content: space-between;
  gap: 16px 0;
  grid-template-columns: repeat(4, 6.5em);
}

.option {
  display: inline-flex;
  align-items: center;

  &__text {
    font-size: 14px;

    &:nth-child(n + 2) {
      margin-left: 4px;
    }
  }
}
</style>
